export default {
  ENABLE_LOADING: 'enable_loading',
  DISABLE_LOADING: 'disable_loading',
  UI_CLEAN_STATE: 'ui_clean_state',
  UPDATE_ALERT_MESSAGE: 'update_alert_message',
  UPDATE_GAME_STAGE: 'update_game_stage',
  UPDATE_CURRENT_SEGMENT: 'update_current_segment',
  UPDATE_IMAGE_BANNER: 'update_image_banner',
}



// WEBPACK FOOTER //
// ./src/entities/ui/types.js